import { PropTypes } from 'react';
import { updateStatuses } from './statuses';
import Notification from './notification';
import Operation from './models/Operation';

export default
    {
        idNameArray: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string
        })),
        updateStatus: PropTypes.oneOf([updateStatuses.initial, updateStatuses.requested, updateStatuses.failure, updateStatuses.success]),
        notification: PropTypes.instanceOf(Notification),
        operation: PropTypes.instanceOf(Operation)
    };


// WEBPACK FOOTER //
// ./src/js/ourPropTypes.js